export default [
  {
    title: 'Home',
    route: 'home',
    icon: null,
  },
  {
    title: 'Product By Portfolio',
    icon: true,
    children: [
      {
        title: 'Communication',
        icon: 'CircleIcon',
        route: 'product-category-communication',
      },
      {
        title: 'Datacomm',
        icon: 'CircleIcon',
        route: 'product-category-datacomm',
      },
      {
        title: 'Internet',
        icon: 'CircleIcon',
        route: 'product-category-internet',
      },
      {
        title: 'Wireless',
        icon: 'CircleIcon',
        route: 'product-category-wireless',
      },
      {
        title: 'Cyber Security',
        icon: 'CircleIcon',
        route: 'product-category-cyber-security',
      },

    ],
  },
  {
    title: 'Product By CFU',
    icon: null,
    children: [
      {
        title: 'EBIS',
        icon: 'CircleIcon',
        route: 'product-cfu-ebis',
      },
      {
        title: 'WIBS',
        icon: 'CircleIcon',
        route: 'product-cfu-wibs',
      },
      // {
      //   title: 'CONS',
      //   icon: 'CircleIcon',
      //   route: 'product-cfu-cons',
      // },
    ],
  },
  // {
  //   title: 'Product By STP',
  //   icon: null,
  //   children: [
  //     {
  //       title: 'Segmentation',
  //       icon: 'CircleIcon',
  //       route: 'product-stp-segment',
  //     },
  //     {
  //       title: 'Targeting',
  //       icon: 'CircleIcon',
  //       route: 'product-stp-target',
  //     }
  //   ]
  // },
  {
    title: 'Product by Category',
    icon: true,
    children: [
      {
        title: 'Bundling',
        icon: 'CircleIcon',
        route: 'product-category-bundling',
      },
      {
        title: 'Fitur',
        icon: 'CircleIcon',
        route: 'product-category-fitur',
      },
      {
        title: 'Produk',
        icon: 'CircleIcon',
        route: 'product-category-produk',
      },
      {
        title: 'Varian',
        icon: 'CircleIcon',
        route: 'product-category-varian',
      },
      {
        title: 'DTP (Digital Touch Point)',
        icon: 'CircleIcon',
        route: 'product-category-dtp',
      },
    ],
  },
  {
    title: 'Nota Dinas',
    icon: null,
    route: 'nodin'
  },
  {
    title: 'Podcast',
    icon: null,
    route: 'podcast'
  },
  {
    title: 'Competitor Comparison',
    icon: null,
    route: 'product-comparison',
  },
  {
    title: 'Product Competency Center',
    icon: null,
    route: 'list-pcc',
  },
  {
    title: 'Product Retirement',
    icon: null,
    route: 'product-retirement',
  },
  {
    title: 'Product Request',
    icon: null,
    route: 'product-request',
  },
  {
    title: 'Consultative Selling',
    icon: null,
    route: 'consultative-selling',
  },
  {
    title: 'Contact Us',
    icon: null,
    route: 'contact-us',
  },
]
